import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Skeleton,
  Typography,
} from '@mui/material'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { useContext } from 'react'

const getProgressColor = (value) => {
  if (value >= 75) return 'success'
  if (value >= 33) return 'warning'
  return 'error'
}

const EvaluadosCard = ({ evaluado, onEvaluadoClick, loading }) => {
  const { handleModal } = useContext(CustomModalContext)

  if (loading) {
    return (
      <Card sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
          <Skeleton variant="circular" width={64} height={64} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={16} />
          </Box>
        </Box>
        <Divider />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="30%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="70%" height={20} />
            </Box>
            <Skeleton variant="circular" width={64} height={64} />
          </Box>
        </CardContent>
      </Card>
    )
  }

  const porcentajeEvaluacion = evaluado.p_evaluacion || 0
  const progressColor = getProgressColor(porcentajeEvaluacion)
  const [apellidos = '', nombre = ''] = (evaluado?.nombre ?? '').split(', ')

  const handleClick = () => {
    if (typeof onEvaluadoClick === 'function') {
      if (evaluado && evaluado.id) {
        onEvaluadoClick(evaluado)
      }
    }
  }

  return (
    <Card
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        cursor: 'pointer',
        transition: 'box-shadow 0.2s, transform 0.2s',
        '&:hover': { boxShadow: 4, transform: 'translateY(-2px)' },
      }}
      onClick={handleClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
        <Avatar
          src={`/assets/images/${evaluado?.imagen}`}
          sx={{ width: 64, height: 64, transition: '0.3s' }}
        />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" lineHeight={1.2}>
            {apellidos}
          </Typography>
          <Typography
            variant="caption"
            sx={{ textTransform: 'uppercase', letterSpacing: 1, color: 'text.secondary' }}
          >
            {nombre}
          </Typography>
        </Box>
      </Box>

      <Divider />

      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ flex: 1, mr: 2 }}>
            <Typography variant="overline" color="text.secondary" lineHeight={1.5}>
              Puesto
            </Typography>
            <Typography variant="body2">{evaluado?.puestos?.[0]?.descripcion ?? '—'}</Typography>
          </Box>

          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={porcentajeEvaluacion}
              color={progressColor}
              size={64}
              thickness={5}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" fontWeight="bold" color={`${progressColor}.main`}>
                {`${Math.round(porcentajeEvaluacion)}%`}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default EvaluadosCard
